import { IPaginationProps } from '@shared/constants/models.const';

export const IGNORE = 'ignore';
export const STORE_SEARCH_INDEX = 'IAS_searchInfo';


interface IMonthNames {
  [language: string]: string[];
}

export const MONTH_NAMES_FR: IMonthNames = {
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  fr: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
  de: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
};

export enum HTTP_ERRORS {
  PageNotFound = 410,
  somethingWentWrong = 500,
  something = 502,
}


export enum STORAGE_KEYS {
  tags = 'IAS-tags',
  lastUrl = 'IAS-lastUrl',
  lastTitle = 'IAS-lastTitle',
  LastUrlParams = 'IAS-lastUrlParams',
}

export enum E_NEWS_TAGS {
  IASB = 1,
  GRI = 2,
  EFRAG = 3,
  Others = 4,
}

export enum E_QPROPS {
  tagType = 'tag-type',
  contentType = 'content-type',
  take = 'take',
  skip = 'skip',
}

export enum E_LINKS {
  Publications = `/${E_QPROPS.tagType}`
}

export enum E_FAVICONS {
  CanadaEng = 'assets/ias-ca-favicon.png',
  CanadaFrench = 'assets/cif-favicon.png',
  UnitedKingdom = 'assets/ias-uk-favicon.png',
  Global = 'assets/ias-favicon.png'
}

export enum E_FILE_PREVIEW {
  placeholder = 'assets/images/document-placeholder.svg',
  xls = 'assets/images/xls-preview.svg',
  doc = 'assets/images/doc-preview.svg',
}

export enum E_LINK_TYPE {
  External = 'External',
  Internal = 'Internal',
}

export enum E_FILE_EXTENSION {
  docx = 'docx',
  xls = 'xls'
}

export enum E_COUNTRY {
  Global = 'Global',
  Canada = 'Canada',
  UnitedKingdom = 'United Kingdom',
}


export enum E_NEWS_TAGS_COLORS {
  None = 'None',
  Blue = 'Blue',
  Green = 'Green',
  Grey = 'Grey',
  White = 'White',
}

export enum E_CONTENT_TYPE {
  All = 0,
  Publications = 1,
  News = 2,
  Meetings = 4,
  Standards = 8,
  Projects = 16,
  Jurisdiction = 32,
  Resources = 64,
  ImportantDates = 1024
}

export enum E_CONTENT_TAG_TYPE {
  Default = 1,
  Financial = 2,
  Sustainability = 4,
  FinancialSustainability = 6,
  All = 7,
  Other = 8,
  OtherFinancial = 10,
  OtherSustainability = 12,
  OtherFinancialSustainability = 14,
  AllThree = 15
}

export enum E_POPULAR_TYPES {
  Publication = 1,
  Standard = 2,
  Jurisdictions = 3,
  Meetings = 4,
  News = 5,
  Projects = 6,
  Resources = 7
}

export enum E_DATE_FORMAT {
  ddMMMyyyy = 'dd MMM yyyy',
  ddMMM_HHmm = 'dd MMM HH:mm',
  ddMMMyyyy_HHmm = 'dd MMM yyyy, HH:mm'
}

export enum E_FR_LOC {
  all = 'all',
  en = 'en',
  de = 'de',
  fr = 'fr',
  caEn = 'en-ca',
  caFr = 'fr-ca',
  enUK = 'en-gb',
}

export enum E_HEADER_LANG {
  'en' = 'en',
  'de' = 'de',
  'fr' = 'fr',
  'en-ca' = 'en',
  'fr-ca' = 'fr',
  'en-gb' = 'en',
}

export enum E_URL_PARTS {
  frLoc = 0,
  rootFolder = 1
}

export enum E_VIEW_TYPE {
  None = '',
  Home = 'home',
  NewsList = 'NewsList',
  NewsDetail = 'NewsDetail',
  PublicationList = 'PublicationList',
  PublicationDetail = 'PublicationDetail',
  MeetingList = 'MeetingList',
  MeetingDetail = 'MeetingDetail',
  ContentPage = 'ContentPage',
  StandardsList = 'StandardsList',
  StandardsDetail = 'StandardsDetail',
  ProjectList = 'ProjectList',
  JurisdictionList = 'JurisdictionList',
  JurisdictionDetail = 'JurisdictionDetail',
  ResourceList = 'ResourceList',
  ResourceDetail = 'ResourceDetail',
  ImportantDatesDetail = 'ImportantDatesDetail',
  Related = 'Related',
  DiscussionDetail = 'DiscussionDetail'
}

export enum E_FOLDER_TYPES {
  Home = 'home',
  News = 'News',
  Details = 'Details',
  Publication = 'Publication',
  Meeting = 'Meeting',
  ImportantDates = 'ImportantDates',
  Standards = 'Standard',
  Folder = 'Folder',
  Project = 'Project',
  Jurisdiction = 'Jurisdiction',
  Resource = 'Resource',
  Related = 'related',
  TagRelated = 'tag-related',
  Discussion = 'Discussion',
  RelatedPublications = 'related-publications',
}

export const DEFAULT_PAGINATION: IPaginationProps = {
  take: 10,
  skip: 0,
};

export enum ProjectStep {
  AgendaDecision = 'AgendaDecision',
  BoardDiscussions = 'BoardDiscussions',
  Completed = 'Completed',
  DecisionOnProjectDirection = 'DecisionOnProjectDirection',
  Deliberations = 'Deliberations',
  Discontinued = 'Discontinued',
  DiscussionPaper = 'DiscussionPaper',
  DraftInterpretation = 'DraftInterpretation',
  DraftPracticeStatement = 'DraftPracticeStatement',
  ExposureDraft = 'ExposureDraft',
  FeedbackStatement = 'FeedbackStatement',
  FinalisedInterpretation = 'FinalisedInterpretation',
  FinalisedStandard = 'FinalisedStandard',
  NearFinalDraft = 'NearFinalDraft',
  NotApplicable = 'NotApplicable',
  NotCommenced = 'NotCommenced',
  OnHold = 'OnHold',
  Other = 'Other',
  PublicConsultation = 'PublicConsultation',
  Redeliberations = 'Redeliberations',
  RequestForInformation = 'RequestForInformation',
  Research = 'Research',
  RevisedExposureDraft = 'RevisedExposureDraft',
  SeeIndividualProjects = 'SeeIndividualProjects',
  Superseded = 'Superseded',
  ToBeDetermined = 'ToBeDetermined'
}

export const ProjectStepLabelMapping: Record<ProjectStep, string> = {
  [ProjectStep.AgendaDecision]: 'Agenda decision',
  [ProjectStep.BoardDiscussions]: 'Board discussions',
  [ProjectStep.Completed]: 'Completed',
  [ProjectStep.DecisionOnProjectDirection]: 'Decision on project direction',
  [ProjectStep.Deliberations]: 'Deliberations',
  [ProjectStep.Discontinued]: 'Discontinued',
  [ProjectStep.DiscussionPaper]: 'Discussion paper',
  [ProjectStep.DraftInterpretation]: 'Draft interpretation',
  [ProjectStep.DraftPracticeStatement]: 'Draft practice statement',
  [ProjectStep.ExposureDraft]: 'Exposure draft',
  [ProjectStep.FeedbackStatement]: 'Feedback statement',
  [ProjectStep.FinalisedInterpretation]: 'Finalised interpretation',
  [ProjectStep.FinalisedStandard]: 'Finalised standard',
  [ProjectStep.NearFinalDraft]: 'Near-final draft',
  [ProjectStep.NotApplicable]: 'Not applicable',
  [ProjectStep.NotCommenced]: 'Not commenced',
  [ProjectStep.OnHold]: 'On hold',
  [ProjectStep.Other]: 'Other',
  [ProjectStep.PublicConsultation]: 'Public consultation',
  [ProjectStep.Redeliberations]: 'Redeliberations',
  [ProjectStep.RequestForInformation]: 'Request for information',
  [ProjectStep.Research]: 'Research',
  [ProjectStep.RevisedExposureDraft]: 'Revised exposure draft',
  [ProjectStep.SeeIndividualProjects]: 'See individual projects',
  [ProjectStep.Superseded]: 'Superseded',
  [ProjectStep.ToBeDetermined]: 'To be determined',
};
